import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _Arrow;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent, createRef } from 'react';
import { getDimensions, closest } from 'utils';
import { Wrapper, Arrow } from './styles';
import { jsxs as _jsxs } from "react/jsx-runtime";
var TOP = 'top';
var BOTTOM = 'bottom';
var LEFT = 'left';
var RIGHT = 'right';
var POSITIONS_PRIORITIES = {
  top: [TOP, BOTTOM, LEFT, RIGHT],
  bottom: [BOTTOM, TOP, LEFT, RIGHT],
  left: [LEFT, RIGHT, TOP, BOTTOM],
  right: [RIGHT, LEFT, TOP, BOTTOM]
};

var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      position: null,
      top: 0,
      left: 0,
      arrowOffset: null
    };
    _this.tipRef = /*#__PURE__*/createRef();

    _this.showTooltip = function () {
      var toggle = _this.props.toggle;
      toggle(true);
    };

    _this.hideTooltip = function () {
      var toggle = _this.props.toggle;
      toggle(false);
    };

    _this.setGlobalListeners = function () {
      var hideOnClickOutside = _this.props.hideOnClickOutside;
      window.addEventListener('scroll', _this.hideTooltip);

      if (hideOnClickOutside) {
        document.addEventListener('mousedown', _this.handleClickOutside);
        document.addEventListener('touchend', _this.handleClickOutside);
      }
    };

    _this.removeGlobalListeners = function () {
      var hideOnClickOutside = _this.props.hideOnClickOutside;
      window.removeEventListener('scroll', _this.hideTooltip);

      if (hideOnClickOutside) {
        document.removeEventListener('mousedown', _this.handleClickOutside);
        document.removeEventListener('touchend', _this.handleClickOutside);
      }
    };

    _this.setListeners = function () {
      var _this$props = _this.props,
          showEvents = _this$props.showEvents,
          hideEvents = _this$props.hideEvents;
      showEvents.forEach(function (event) {
        _this.target.addEventListener(event, _this.showTooltip);
      });
      hideEvents.forEach(function (event) {
        _this.target.addEventListener(event, _this.hideTooltip);
      });
    };

    _this.removeListeners = function () {
      var _this$props2 = _this.props,
          showEvents = _this$props2.showEvents,
          hideEvents = _this$props2.hideEvents;
      showEvents.forEach(function (event) {
        _this.target.removeEventListener(event, _this.showTooltip);
      });
      hideEvents.forEach(function (event) {
        _this.target.removeEventListener(event, _this.hideTooltip);
      });
    };

    _this.getTarget = function () {
      var target = _this.props.target;
      _this.target = document.getElementById(target) || _this.tipRef.current.parentNode.querySelector('[data-tip-target]') || _this.tipRef.current.parentNode;
    };

    _this.updateTooltip = function () {
      var positionOptions = _this.getPosition();

      _this.setState(_objectSpread({}, positionOptions));
    };

    _this.getDirection = function (position) {
      return position === TOP || position === BOTTOM ? 'vertical' : 'horizontal';
    };

    _this.calculatePosition = function (t, b, l, r, fullTipWidth, fullTipHeight, offset) {
      var position = _this.props.position;
      var _document$documentEle = document.documentElement,
          clientHeight = _document$documentEle.clientHeight,
          clientWidth = _document$documentEle.clientWidth;
      var positionsPosibility = {
        top: t - offset > 0,
        bottom: b + offset + fullTipHeight < clientHeight,
        left: l - offset > 0,
        right: r + offset + fullTipWidth < clientWidth
      };
      var resultPosition = POSITIONS_PRIORITIES[position].find(function (p) {
        return positionsPosibility[p];
      });
      return resultPosition || position;
    };

    _this.calculateOffset = function (t, b, l, r, offset, position, vericalLeft, horizontalTop, tipWidth, tipHeight) {
      var _document$documentEle2 = document.documentElement,
          clientWidth = _document$documentEle2.clientWidth,
          clientHeight = _document$documentEle2.clientHeight;

      var direction = _this.getDirection(position);

      var top = position === TOP ? t : b;
      var left = position === LEFT ? l : r;

      if (direction === 'vertical') {
        var leftOffset = vericalLeft - offset;
        var rightOffset = vericalLeft + tipWidth + offset;

        if (leftOffset < 0) {
          return {
            top: top,
            left: offset,
            arrowOffset: 50 - (Math.abs(vericalLeft) + offset) * 100 / tipWidth
          };
        }

        if (rightOffset > clientWidth) {
          return {
            top: top,
            left: clientWidth - tipWidth - offset,
            arrowOffset: 50 + Math.abs(rightOffset - clientWidth) * 100 / tipWidth
          };
        }

        return {
          top: top,
          left: vericalLeft,
          arrowOffset: null
        };
      }

      if (direction === 'horizontal') {
        var topOffset = horizontalTop - offset;
        var bottomOffset = horizontalTop + tipHeight + offset;

        if (topOffset < 0) {
          return {
            top: offset,
            left: left,
            arrowOffset: 50 - (Math.abs(horizontalTop) + offset) * 100 / tipHeight
          };
        }

        if (bottomOffset > clientHeight) {
          return {
            top: clientHeight - tipHeight - offset,
            left: left,
            arrowOffset: 50 + Math.abs(bottomOffset - clientHeight) * 100 / tipHeight
          };
        }

        return {
          top: horizontalTop,
          left: left,
          arrowOffset: null
        };
      }

      return null;
    };

    _this.getPosition = function () {
      var _this$props3 = _this.props,
          hideArrow = _this$props3.hideArrow,
          propOffset = _this$props3.offset;
      var triangleHeight = hideArrow ? 0 : 4;
      var margin = 4;
      var offset = propOffset || 10;

      var _getDimensions = getDimensions(_this.target),
          targetTop = _getDimensions.top,
          targetLeft = _getDimensions.left,
          targetWidth = _getDimensions.width,
          targetHeight = _getDimensions.height;

      var _getDimensions2 = getDimensions(_this.tipRef.current),
          tipWidth = _getDimensions2.width,
          tipHeight = _getDimensions2.height;

      var t = targetTop - tipHeight - triangleHeight - margin;
      var b = targetTop + targetHeight + triangleHeight + margin;
      var l = targetLeft - tipWidth - triangleHeight - margin;
      var r = targetLeft + targetWidth + triangleHeight + margin;
      var vericalLeft = targetLeft + targetWidth / 2 - tipWidth / 2;
      var horizontalTop = targetTop + targetHeight / 2 - tipHeight / 2;
      var fullTipWidth = tipWidth + triangleHeight + margin;
      var fullTipHeight = tipHeight + triangleHeight + margin;

      var resultPosition = _this.calculatePosition(t, b, l, r, fullTipWidth, fullTipHeight, offset);

      var calculatedOffset = _this.calculateOffset(t, b, l, r, offset, resultPosition, vericalLeft, horizontalTop, tipWidth, tipHeight);

      return _objectSpread({
        position: resultPosition
      }, calculatedOffset);
    };

    _this.handleClickOutside = function (event) {
      if (_this.tipRef.current && !closest(event.target, _this.target)) {
        _this.hideTooltip();
      }
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getTarget();
      this.setListeners();
      this.updateTooltip();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          show = _this$props4.show,
          target = _this$props4.target;

      if (target && target !== prevProps.target) {
        this.getTarget();
      }

      if (show !== prevProps.show) {
        if (show) {
          this.setGlobalListeners();
        } else {
          this.removeGlobalListeners();
        }
      }

      this.updateTooltip();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      this.removeGlobalListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          hideArrow = _this$props5.hideArrow,
          style = _this$props5.style,
          show = _this$props5.show,
          fixedPosition = _this$props5.fixedPosition,
          width = _this$props5.width,
          height = _this$props5.height;
      return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
        ref: this.tipRef,
        style: style,
        show: show,
        fixedPosition: fixedPosition,
        width: width,
        height: height
      }, this.state), {}, {
        children: [!hideArrow && (_Arrow || (_Arrow = /*#__PURE__*/_jsx(Arrow, {}))), show && children]
      }));
    }
  }]);

  return Tooltip;
}(PureComponent);

Tooltip.defaultProps = {
  children: null,
  position: RIGHT,
  target: '',
  toggle: function toggle() {},
  style: {},
  fixedPosition: false,
  show: null,
  hideArrow: false,
  offset: 10,
  showEvents: [],
  hideEvents: [],
  hideOnClickOutside: true,
  width: null,
  height: null
};
export default Tooltip;